<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师上课记录</Breadcrumb-item>
        <Breadcrumb-item>学生常规请假详情</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="5">
            <Form-item label="学生ID">
              <Input name="uid" v-model="queryParam.uid"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" :listUrl="listUrl"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>
  export default {
    props: {
      listUrl: {
        type: String,
        default: '/bc/listUserLeaveDetail'
      }
    },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        searchLoading: false,
        reload: 0,
        queryParam: {
          tchId: '',
          uid: '',
          lessonStartTime: '',
          lessonEndTime: '',
        },
        title: [
          {
            title: '学生ID、姓名',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let row = params.row
              return h('span', (row.uid || '') + '-' + (row.userNickname || ''))
            }
          },
          {
            title: '上课时间',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let row = params.row
              return h('span', row.lsnBeginTime ? $moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') : '')
            }
          },
          {
            title: '课程状态',
            align: 'center',
            width: 110,
            render: (h, params) => {
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '请假时间',
            align: 'center',
            width: 240,
            render: (h, params) => {
              let row = params.row
              let start = row.leaveStartTime ? $moment(row.leaveStartTime, 'X').format('YYYY-MM-DD HH:mm') : ''
              let end = row.leaveEndTime ? $moment(row.leaveEndTime, 'X').format('YYYY-MM-DD HH:mm') : ''
              if (!start && !end) {
                return h('span', '')
              }
              if (!end) {
                return h('span', start)
              }
              return h('span', start + ' ~ ' + end)
            }
          },
        ]
      }
    },
    created: function () {
      this.queryParam.tchId = localStorage.tchId
      this.queryParam.lessonStartTime = localStorage.startTime
      this.queryParam.lessonEndTime = localStorage.endTime
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
    }
  }
</script>



// WEBPACK FOOTER //
// UserLeaveDetail.vue?bc14374e